import type { FC } from "react";

import { StepperItem } from "@/ui/components/data-display/Stepper/StepperItem";
import {
  STEPPER_LIST_CLASS,
  type TStepperConnectorState,
  type TStepperProps,
} from "@/ui/components/data-display/Stepper/Stepper.config";
import { cn } from "@/ui/lib/utils";

export const Stepper: FC<TStepperProps> = (
  {
    steps,
    className,
    ...props
  },
) => (
  <ol
    {...props}
    data-component="Stepper"
    className={cn(STEPPER_LIST_CLASS, className)}
  >
    { steps.map((step, index) => {
      let connector: TStepperConnectorState | undefined;

      if (steps[index + 1]) {
        connector = step.state === "complete" ? "complete" : "incomplete";
      }

      return (
        <StepperItem
          key={step.id}
          type={step.type}
          label={step.label}
          state={step.state}
          connector={connector}
        />
      );
    }) }
  </ol>
);

Stepper.displayName = "Stepper";
